import React from "react";

// Import logos
import logo4founders from "@/assets/logos/4founders_logo.png";
import logoAFS from "@/assets/logos/AFS_logo.png";
import logoEholo from "@/assets/logos/eholo_logo.png";
import logoEncomenda from "@/assets/logos/encomenda_logo.png";
import logoHabitacion from "@/assets/logos/habitacion_logo.png";
import logoKintai from "@/assets/logos/kintai_logo.png";
import logoOkticket from "@/assets/logos/okticket_logo.png";
import logoSusmies from "@/assets/logos/susmies_logo.png";
import logoBanoleon from "@/assets/logos/banoleon_logo.png";
import logoEcostars from "@/assets/logos/ecostars_logo.png";
import logoBarefoot from "@/assets/logos/barefoot_logo.png";

const HeroSection = () => {
  const logos = [
    { name: "4Founders", src: logo4founders },
    { name: "AFS", src: logoAFS },
    { name: "Eholo", src: logoEholo },
    { name: "Encomenda", src: logoEncomenda },
    { name: "Habitación", src: logoHabitacion },
    { name: "Kintai", src: logoKintai },
    { name: "OKTicket", src: logoOkticket },
    { name: "Susmies", src: logoSusmies },
    { name: "Baño León Abogados", src: logoBanoleon },
    { name: "Ecostars", src: logoEcostars },
    { name: "Barefoot You", src: logoBarefoot },
  ];

  return (
    <section className="home2-hero">
      <div className="home2-hero-content">
        <h1 className="home2-hero-headline">
          Orden financiero.<br />
          Criterio para tomar mejores decisiones.
        </h1>
        <h2 className="home2-hero-subheadline">
          Trabajamos datos financieros para convertirlos en conversaciones estratégicas.
        </h2>

        {/* Carousel de logos */}
        <div className="home2-trust-section">
          <p className="home2-trust-label">Confían en nosotros</p>
          <div className="home2-logos-carousel">
            <div className="home2-logos-track">
              {/* Grupo A */}
              <div className="home2-logos-group">
                {logos.map((logo, index) => (
                  <div key={`a-${index}`} className="home2-logo-item">
                    <img 
                      src={logo.src} 
                      alt={logo.name} 
                      className="home2-logo-img"
                    />
                  </div>
                ))}
              </div>
              {/* Grupo B (duplicado para loop infinito) */}
              <div className="home2-logos-group" aria-hidden="true">
                {logos.map((logo, index) => (
                  <div key={`b-${index}`} className="home2-logo-item">
                    <img 
                      src={logo.src} 
                      alt={logo.name} 
                      className="home2-logo-img"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
